"use client"

import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Shield, AlertTriangle } from "lucide-react"
import { useLocalStorage } from "@/hooks/use-local-storage"

export default function AgeConfirmation() {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [ageConfirmation, setAgeConfirmation] = useLocalStorage<string | null>("age-confirmation", null)

  useEffect(() => {
    if (!ageConfirmation) {
      setShowConfirmation(true)
    }
  }, [ageConfirmation])

  const confirmAge = () => {
    setAgeConfirmation("confirmed")
    setShowConfirmation(false)
  }

  const declineAge = () => {
    setAgeConfirmation("declined")
    setShowConfirmation(false)
    // Redirect to a safe page or show message
    window.location.href = "https://www.google.com"
  }

  return (
    <Dialog open={showConfirmation} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl font-bold text-gray-800">
            <Shield className="h-6 w-6 text-green-600" />
            Age Verification Required
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="flex items-start gap-3 p-4 bg-amber-50 border border-amber-200 rounded-lg">
            <AlertTriangle className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
            <div>
              <h3 className="font-semibold text-amber-800 mb-1">Important Notice</h3>
              <p className="text-sm text-amber-700">
                This website contains products that may not be suitable for individuals under 18 years of age. 
                By proceeding, you confirm that you are at least 18 years old.
              </p>
            </div>
          </div>
          
          <p className="text-sm text-gray-600">
            You must be 18 years or older to access this pharmacy website. 
            Some products may require additional age verification at checkout.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 pt-4">
            <Button
              variant="outline"
              onClick={declineAge}
              className="flex-1"
            >
              I'm under 18
            </Button>
            <Button
              onClick={confirmAge}
              className="flex-1 bg-green-600 hover:bg-green-700"
            >
              I'm 18 or older
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
} 